import { Box, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { dropdownWrapperStyle } from './dropdowns/utils';
/**
 * The audit frames AWS captures during the liveness check. Internal only: the
 * admin job endpoint is the only one that returns their URLs.
 */
export const LivenessImages = ({ urls }) => {
    const { tokens } = useContext(ThemeContext).theme;
    if (urls.length === 0) {
        return null;
    }
    return (React.createElement(Box, { "data-test": "job-liveness-images", marginBottom: "spacing.large", style: dropdownWrapperStyle },
        React.createElement(Text, { style: {
                color: tokens.colors.gray800,
                textTransform: 'uppercase',
                marginBottom: '10px'
            }, variation: "footnote" }, "Liveness Images"),
        React.createElement(Box, { display: "flex", style: { flexWrap: 'wrap', gap: '10px' } }, urls.map((url, index) => (React.createElement("a", { href: url, key: url, rel: "noreferrer", target: "_blank" },
            React.createElement("img", { alt: `Liveness capture ${index + 1}`, src: url, style: {
                    maxWidth: '150px',
                    borderRadius: '5px',
                    border: `1px solid ${tokens.colors.gray100}`
                } })))))));
};
